import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-geographic-node-select',
  standalone: false,
  templateUrl: './geographic-node-select.component.html',
  styleUrl: './geographic-node-select.component.scss'
})
export class GeographicNodeSelectComponent {
  @Input() value: string | null = null;
  @Input() options: { id: string; label: string }[] = [];
  @Output() valueChange = new EventEmitter<string>();

  onSelectChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    this.value = select.value;
    this.valueChange.emit(this.value);
  }
}
